<div class="flex flex-wrap gap-2">
  @for (option of options; track option) {
  <button [ngClass]="{
        'bg-chip-selectedColor !text-chip-selectedText': selectedOptionId === option.id,
        'hover:bg-background-color hover:opacity-50': selectedOptionId !== option.id,
      }"
    class="px-3 py-1.5 rounded-full text-xs font-poppins font-medium cursor-pointer border border-chip-textColor text-chip-textColor transition-all duration-200 ease-in-out min-w-[40px] desktop:min-w-[80px]"
    (click)="selectOption(option.id)" type="button">
    {{ option.label }}
  </button>
  }
</div>